import * as React from "react";
import request from "src/utils/request";
import MissionsAccordion from "src/scenes/dashboard/overview-components/missions-accordion";
import { useAuth } from "src/components/providers/auth-context";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import AchievementsAccordion from "src/scenes/dashboard/overview-components/achievements-accordion";
import { Grid } from "@mui/material";
import TeamMissionDeleteModal from "src/scenes/teams/team/team-mission-delete-modal";

const MissionsAchievementsTemplate = (isUnintegrated) => {
    const [activeMissions, setActiveMissions] = React.useState([]);
    const [isMissionsModalOpen, setIsMissionModalOpen] = React.useState(false);
    const [isMissionsDeleteModalOpen, setIsMissionDeleteModalOpen] = React.useState(false);
    const [toDeleteId, setToDeleteId] = React.useState("");
    const [toDeleteKey, setToDeleteKey] = React.useState("");

    const { isDemo } = useAuth();

    const activeIntegrations = useActiveIntegrations();
    const getActiveMissions = async () => {
        let response;
        if (isDemo) {
            response = (
                await import("src/scenes/teams/dashboard/mock-data/team-active-missions-mock-data")
            ).default;
        } else {
            response = await request(`/api/missions/active`, {
                method: "GET",
            });
        }
        setActiveMissions(response);
        return null;
    };

    React.useEffect(() => {
        getActiveMissions();
    }, [activeIntegrations.status]);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={8}>
                    <MissionsAccordion
                        handleModalChange={() => setIsMissionModalOpen(!isMissionsModalOpen)}
                        isDemo={isDemo}
                        isMissionsDeleteModalOpen={isMissionsDeleteModalOpen}
                        setIsMissionsDeleteModalOpen={setIsMissionDeleteModalOpen}
                        setToDeleteId={setToDeleteId}
                        setToDeleteKey={setToDeleteKey}
                        activeMissions={activeMissions}
                    />
                </Grid>
                <Grid item md={4}>
                    <AchievementsAccordion isDemo={isDemo} isUnintegrated={isUnintegrated} mb={4} />
                </Grid>
            </Grid>
            <TeamMissionDeleteModal
                missionId={toDeleteId}
                missionKey={toDeleteKey}
                open={isMissionsDeleteModalOpen}
                getActiveMissions={getActiveMissions}
                handleClose={() => setIsMissionDeleteModalOpen(false)}
            />
        </>
    );
};

export default MissionsAchievementsTemplate;
